import React from 'react';
import { useParams } from 'react-router-dom';

import { useUserInfo } from '../../context/UserInfoContext';
import { useGetMultiAccessUserDetail } from '../../endpoints/multiaccess/useGetMultiAccssUserDetail';
import MultiAccessClientEdit from './kam/MultiAccessClientEdit';
import MultiAccessKamCreateEdit from './manager/MultiAccessKamCreateEdit/MultiAccessKamCreateEdit';

const MultiAccessEdit = () => {
  const { userInfo } = useUserInfo();
  const { userId } = useParams();
  const { data, isLoading } = useGetMultiAccessUserDetail(userId);

  if (isLoading) {
    return null;
  }

  return userInfo.role === 'kam' ? (
    <MultiAccessClientEdit companyName={data.user.company} defaultValues={data.user} />
  ) : (
    <MultiAccessKamCreateEdit isEditMode defaultValues={data.user} />
  );
};

export default MultiAccessEdit;
